module.exports = __webpack_public_path__ + "img/paysucc.44cb43da.png";